import React, { forwardRef, InputHTMLAttributes } from 'react'
import { RadioElement, RadioLabel, RadioWrapper } from './styles'

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: boolean
  size?: number
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, error, size, ...props }: RadioProps, reference) => {
    return (
      <RadioWrapper size={size} htmlFor={props.id ?? props.name} error={error}>
        <RadioElement id={props.id ?? props.name} type="radio" {...props} ref={reference} />
        {label && <RadioLabel error={error}>{label}</RadioLabel>}
      </RadioWrapper>
    )
  }
)

Radio.displayName = 'Radio'
